import React, { useState } from "react";
import * as yup from "yup";
import build_path from "utils/build_path";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Formik, Form, Field, ErrorMessage } from "formik";
import routes from "routing/routes";
import styles from "./bottom_tab.module.css";

const BookingManagment = ({ open, setOpen }) => {
  const [toastText, setToastText] = useState(null);
  const getSchema = yup.object({
    confirmation_no: yup.string().required("confirmation number is required"),
    email: yup
      .string()
      .required("Valid email is required.")
      .email("Please enter a valid email address."),
  });
  const history = useHistory();
  const handleSubmit = (values, { setSubmitting }) => {
    setToastText(null);
    let confirmationNo = values?.confirmation_no?.replace(
      /^(osa-|OSA-|hbe-|HBE-|GHA-|gha-|hpt-|HPT-)/i,
      "",
    );

    getBooking(confirmationNo, values?.email);
    setSubmitting(false);
  };

  const getBooking = async (confirmation_no, email) => {
    const data = await ApiActions.fetchBooking(confirmation_no?.trim());

    if (data?.data?.length > 0) {
      let apiDate = new Date(data.data[0].attributes.arrival_date);
      let now = new Date();
      apiDate.setHours(23, 59, 59, 999);

      if (now?.getTime() > apiDate?.getTime()) {
        setToastText("Cant Modify it As date is passed already!");
      } else if (data.data[0].attributes.customer.mail.toLowerCase() !== email.toLowerCase()) {
        setToastText("Email Don't Match!");
      } else if (data.data[0].attributes.status === "cancelled") {
        setToastText("This Booking is Already Cancelled!");
      } else {
        const queryParams = {
          channelId: data?.data[0]?.attributes?.channel_id,
          confirmation_no: confirmation_no?.trim(),
        };
        const PagePath = build_path(history.location.search, routes.updateBookingPage, queryParams);
        const myModal = document.getElementsByClassName("modal-backdrop")[0];
        const body = document.getElementsByClassName("modal-open")[0];

        body.classList.remove("modal-open");
        // Dismiss the modal by modifying its properties

        if (myModal) {
          myModal.classList.remove("modal-backdrop");
          myModal.classList.remove("show");
          myModal.classList.remove("fade");
        }
        history.push(PagePath);
      }
    } else {
      setToastText("Confirmation No is invalid");
    }
  };

  return (
    <div className={`${styles.bottom_sheet} ${open ? styles.show : ""}`}>
      <div className={styles.sheet_content}>
        <div className="d-flex flex-column align-items-start w-100 ">
          <p className="mt-2 mb-n2">
            Manage your reservation with <b>ease—view,</b> <b>modify,</b> or{" "}
            <b>cancel your booking.</b>
          </p>
          <p>
            To proceed, please enter the email address used during booking along with the
            confirmation number you received.
          </p>
          <Formik
            initialValues={{ email: "", confirmation_no: "" }}
            validationSchema={getSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="w-100">
                <label className={styles.label}>Booking Confirmation Number:</label>
                <Field type="text" name="confirmation_no" className={styles.input} />
                <ErrorMessage name="confirmation_no" component="div" className={styles.error} />

                <label className={styles.label}>Email:</label>
                <Field type="email" name="email" className={styles.input} />
                <ErrorMessage name="email" component="div" className={styles.error} />
                <div className={styles.btngroup}>
                  <button type="submit" disabled={isSubmitting} className={styles.submitbtn}>
                    Retrieve Booking
                  </button>
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    data-dismiss="modal"
                    className={styles.cancelbtn}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        {toastText && (
          <MyToast
            text={toastText}
            type={"error"}
            show={toastText !== null}
            setShow={() => setToastText(null)}
          />
        )}
      </div>
    </div>
  );
};
export default BookingManagment;
